import moment from 'moment'
import Papa from 'papaparse'
import { getAuthentication } from '../api/auth'
import { readings } from './readings'
// import { readingsAgg } from './readings.agg'
// import { readingsSample } from './readings.sample'
// import { residuals } from './residuals'

const getRecordsFromFile = () => {
  var csv = Papa.parse(readings, {
    header: true,
  })

  const data = csv.data

  data.forEach((d) => {
    d.consumptionTotal = parseFloat(d.consumptionTotal)
    d.consumptionVazio = parseFloat(d.consumptionVazio)
    d.consumptionSuperVazio = parseFloat(d.consumptionSuperVazio)
    d.consumptionPontas = parseFloat(d.consumptionPontas)
    d.consumptionCheias = parseFloat(d.consumptionCheias)
    d.brakingTotal = parseFloat(d.brakingTotal)
    d.brakingVazio = parseFloat(d.brakingVazio)
    d.brakingSuperVazio = parseFloat(d.brakingSuperVazio)
    d.brakingPontas = parseFloat(d.brakingPontas)
    d.brakingCheias = parseFloat(d.brakingCheias)
    // d.consumptionGross = parseFloat(d.consumptionGross)

    d.consumptionKm = parseFloat(d.consumptionKm)
    d.brakingKm = parseFloat(d.brakingKm)
    d.kmTraveled = parseFloat(d.kmTraveled)

    d.opDt = moment(d.opDt)
    d.fromDt = moment(d.fromDt)
    d.toDt = moment(d.toDt)
    d.year = parseInt(d.year)
    d.month = parseInt(d.month)
  })


  return data
}

// const getAggRecordsFromFile = () => {
//   var csv = Papa.parse(readingsAgg, {
//     header: true
//   })

//   const data = csv.data

//   data.forEach(d => {
//     d.brakingKm = parseFloat(d.brakingKm)
//     d.consumptionKm = parseFloat(d.consumptionKm)
//     d.year = parseInt(d.year)
//     d.month = parseInt(d.month)
//     d.braking = parseFloat(d.braking)
//     d.consumption = parseFloat(d.consumption)
//     d.kmTraveled = parseFloat(d.kmTraveled)
//     d.opDt = moment(d.opDt)
//   })

//   return data
// }

// const getResidualsFromFile = () => {
//   var csv = Papa.parse(residuals, {
//     header: true
//   })

//   const data = csv.data

//   data.forEach(d => {
//     d.year = parseInt(d.year)
//     d.month = parseInt(d.month)
//     d.day = parseInt(d.day)
//     d.consumption = parseFloat(d.consumption)
//     d.opDt = moment(d.opDt)
//   })

//   return data
// }

const RECORDS = getRecordsFromFile()
// const AGG_RECORDS = getAggRecordsFromFile()
// const RESIDUALS = getResidualsFromFile()

const OPERATORS = [...new Set(RECORDS.map((r) => r.operatorName))]
const SST = [...new Set(RECORDS.map((r) => r.sst))]
const FLEET = [...new Set(RECORDS.map((r) => r.fleetGroup))]
const SERVICES = [...new Set(RECORDS.map((r) => r.service))]
// const OPERATORS = [... new Set(AGG_RECORDS.map(r => r.operatorName)) ]
// const SST = [... new Set(AGG_RECORDS.map(r => r.sst)) ]
// const FLEET = [... new Set(AGG_RECORDS.map(r => r.fleet)) ]
// const SERVICES = [... new Set(AGG_RECORDS.map(r => r.service)) ]
// const ROUTES = []

export const authAdmin = () => {
  return {
    name: 'João Gamboa',
    email: 'joaosousa_gamboa@siemens.com',
    isAdmin: false,
    isReportIssuer: true,
    entity: 'IP',
  }
}

export const authIssuer = () => {
  return {
    name: 'Convidado',
    email: 'convidado@ip.pt',
    isAdmin: false,
    isReportIssuer: true,
    entity: 'IP',
  }
}

export const authOperator = (operator) => {
  return {
    name: 'Convidado',
    email: 'convidado@cp.pt',
    isAdmin: false,
    isReportIssuer: false,
    entity: operator,
  }
}

export const randBetween = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

// const getResidualSum = (year, month) => {
//   return RESIDUALS.filter(r => r.year === year && r.month === month).map(r => r.consumption).reduce((a, b) => a + b)
// }

// const getResidualSumFromTo = (from, to) => {
//   return RESIDUALS.filter(r => r.opDt.isBetween(from, to, null, '[]')).map(r => r.consumption).reduce((a, b) => a + b)
// }

export const generateReports = () => {
  let reportGroups = {}

  // for (const record of AGG_RECORDS) {
  for (const record of RECORDS) {
    const yearMonth = record.opDt.format('YYYY-MM')

    // Initialize group report if not exists
    if (!(yearMonth in reportGroups)) {
      reportGroups[yearMonth] = {
        id: `IP_${record.year}_${record.month}`,
        year: record.year,
        month: record.month,
        createdAt: record.opDt.clone(),

        consumptionTotal: 0,
        consumptionVazio: 0,
        consumptionSuperVazio: 0,
        consumptionPontas: 0,
        consumptionCheias: 0,
        brakingTotal: 0,
        brakingVazio: 0,
        brakingSuperVazio: 0,
        brakingPontas: 0,
        brakingCheias: 0,
        consumptionGross: 0,
        consumptionKm: 0,
        brakingKm: 0,
        kmTraveled: 0,

        numTrips: 0,
        reports: {},
      }
    }

    const rg = reportGroups[yearMonth]

    // Initialize sub report if not exists
    if (!(record.operatorName in rg.reports)) {
      rg.reports[record.operatorName] = {
        id: `${record.operatorName}_${record.year}_${record.month}`,
        year: record.year,
        operatorName: record.operatorName,
        month: record.month,
        createdAt: record.opDt.clone(),
        publishedAt: Math.random() < 0.9 ? record.opDt.clone() : undefined,

        consumptionTotal: 0,
        consumptionVazio: 0,
        consumptionSuperVazio: 0,
        consumptionPontas: 0,
        consumptionCheias: 0,
        brakingTotal: 0,
        brakingVazio: 0,
        brakingSuperVazio: 0,
        brakingPontas: 0,
        brakingCheias: 0,
        consumptionGross: 0,
        consumptionKm: 0,
        brakingKm: 0,
        kmTraveled: 0,

        numTrips: 0,
        // records: []
      }
    }

    const sr = rg.reports[record.operatorName]

    // Add data to sub report
    // sr['consumption'] += record.consumption
    // sr['braking'] += record.braking
    // sr['kmTraveled'] += record.kmTraveled
    // sr['consumptionKm'] = sr['consumption'] / sr['kmTraveled']
    // sr['brakingKm'] = sr['braking'] / sr['kmTraveled']

    sr['consumptionTotal'] += record.consumptionTotal
    sr['consumptionVazio'] += record.consumptionVazio
    sr['consumptionSuperVazio'] += record.consumptionSuperVazio
    sr['consumptionPontas'] += record.consumptionPontas
    sr['consumptionCheias'] += record.consumptionCheias
    sr['brakingTotal'] += record.brakingTotal
    sr['brakingVazio'] += record.brakingVazio
    sr['brakingSuperVazio'] += record.brakingSuperVazio
    sr['brakingPontas'] += record.brakingPontas
    sr['brakingCheias'] += record.brakingCheias
    sr['consumptionGross'] += record.consumptionGross

    sr['kmTraveled'] += record.kmTraveled

    sr['consumptionKm'] = sr['consumptionTotal'] / sr['kmTraveled']
    sr['brakingKm'] = sr['brakingTotal'] / sr['kmTraveled']

    sr['numTrips'] += 1
    // sr['records'].push(record)

    // Add data to group report

    rg['consumptionTotal'] += record.consumptionTotal
    rg['consumptionVazio'] += record.consumptionVazio
    rg['consumptionSuperVazio'] += record.consumptionSuperVazio
    rg['consumptionPontas'] += record.consumptionPontas
    rg['consumptionCheias'] += record.consumptionCheias
    rg['brakingTotal'] += record.brakingTotal
    rg['brakingVazio'] += record.brakingVazio
    rg['brakingSuperVazio'] += record.brakingSuperVazio
    rg['brakingPontas'] += record.brakingPontas
    rg['brakingCheias'] += record.brakingCheias
    rg['consumptionGross'] += record.consumptionGross

    rg['kmTraveled'] += record.kmTraveled

    rg['consumptionKm'] = rg['consumptionTotal'] / rg['kmTraveled']
    rg['brakingKm'] = rg['brakingTotal'] / rg['kmTraveled']

    // rg['consumption'] += record.consumption
    // rg['braking'] += record.braking
    // rg['kmTraveled'] += record.kmTraveled
    // rg['consumptionKm'] = rg['consumption'] / rg['kmTraveled']
    // rg['brakingKm'] = rg['braking'] / rg['kmTraveled']
    rg['numTrips'] += 1
  }

  // Calculate variations

  function addVariations(rep, operatorName) {
    const prevMonth = rep.createdAt.clone().subtract(1, 'month').format('YYYY-MM')
    // const prevYear = rep.createdAt.clone().subtract(1, 'year').format('YYYY-MM')

    if (prevMonth in reportGroups) {
      const pmRg = reportGroups[prevMonth]

      let pm = operatorName ? pmRg.reports[operatorName] : pmRg

      rep['numTripsVar'] = (rep['numTrips'] - pm['numTrips']) / pm['numTrips']
      rep['kmTraveledVar'] = (rep['kmTraveled'] - pm['kmTraveled']) / pm['kmTraveled']
      rep['consumptionVar'] = (rep['consumptionTotal'] - pm['consumptionTotal']) / pm['consumptionTotal']
      rep['brakingVar'] = (rep['brakingTotal'] - pm['brakingTotal']) / pm['brakingTotal']
      rep['consumptionKmVar'] = (rep['consumptionKm'] - pm['consumptionKm']) / pm['consumptionKm']
      rep['brakingKmVar'] = (rep['brakingKm'] - pm['brakingKm']) / pm['brakingKm']
      rep['residualVar'] = (rep['residual'] - pm['residual']) / pm['residual']
    } else {
      rep['numTripsVar'] = undefined
      rep['kmTraveledVar'] = undefined
      rep['consumptionVar'] = undefined
      rep['brakingVar'] = undefined
      rep['consumptionKmVar'] = undefined
      rep['brakingKmVar'] = undefined
      rep['residualVar'] = undefined
    }
  }

  Object.keys(reportGroups).forEach((key) => {
    const rg = reportGroups[key]
    
    // rg['residual'] = getResidualSum(rg.year, rg.month)
    addVariations(rg)
    
    Object.keys(rg.reports).forEach((k) => {
      addVariations(rg.reports[k], k)
    })
  })

  // Convert dicts into lists
  reportGroups = Object.entries(reportGroups).map((r) => r[1])
  for (const rg of reportGroups) {
    rg.reports = Object.entries(rg.reports).map((r) => r[1])
  }

  return reportGroups
}

//   function addVariations(rep, operatorName) {
//     const prevMonth = rep.createdAt.clone().subtract(1, 'month').format('YYYY-MM')
//     const prevYear = rep.createdAt.clone().subtract(1, 'year').format('YYYY-MM')

//     if (prevMonth in reportGroups) {
//       const pmRg = reportGroups[prevMonth]

//       let pm = operatorName ? pmRg.reports[operatorName] : pmRg

//       rep['numTripsLastMonthVar'] = (rep['numTrips'] - pm['numTrips']) / pm['numTrips']
//       rep['kmTraveledLastMonthVar'] = (rep['kmTraveled'] - pm['kmTraveled']) / pm['kmTraveled']
//       rep['consumptionLastMonthVar'] = (rep['consumption'] - pm['consumption']) / pm['consumption']
//       rep['brakingLastMonthVar'] = (rep['braking'] - pm['braking']) / pm['braking']
//       rep['consumptionKmLastMonthVar'] = (rep['consumptionKm'] - pm['consumptionKm']) / pm['consumptionKm']
//       rep['brakingKmLastMonthVar'] = (rep['brakingKm'] - pm['brakingKm']) / pm['brakingKm']
//       rep['residualLastMonthVar'] = (rep['residual'] - pm['residual']) / pm['residual']
//     } else {
//       rep['numTripsLastMonthVar'] = undefined
//       rep['kmTraveledLastMonthVar'] = undefined
//       rep['consumptionLastMonthVar'] = undefined
//       rep['brakingLastMonthVar'] = undefined
//       rep['consumptionKmLastMonthVar'] = undefined
//       rep['brakingKmLastMonthVar'] = undefined
//       rep['residualLastMonthVar'] = undefined
//     }

//     if (prevYear in reportGroups) {
//       const pyRg = reportGroups[prevYear]
//       let py = operatorName ? pyRg.reports[operatorName] : pyRg

//       rep['numTripsLastYearVar'] = (rep['numTrips'] - py['numTrips']) / py['numTrips']
//       rep['kmTraveledLastYearVar'] = (rep['kmTraveled'] - py['kmTraveled']) / py['kmTraveled']
//       rep['consumptionLastYearVar'] = (rep['consumption'] - py['consumption']) / py['consumption']
//       rep['brakingLastYearVar'] = (rep['braking'] - py['braking']) / py['braking']
//       rep['consumptionKmLastYearVar'] = (rep['consumptionKm'] - py['consumptionKm']) / py['consumptionKm']
//       rep['brakingKmLastYearVar'] = (rep['brakingKm'] - py['brakingKm']) / py['brakingKm']
//       rep['residualLastYearVar'] = (rep['residual'] - py['residual']) / py['residual']
//     } else {
//       rep['numTripsLastYearVar'] = undefined
//       rep['kmTraveledLastYearVar'] = undefined
//       rep['consumptionLastYearVar'] = undefined
//       rep['brakingLastYearVar'] = undefined
//       rep['consumptionKmLastYearVar'] = undefined
//       rep['brakingKmLastYearVar'] = undefined
//       rep['residualLastYearVar'] = undefined
//     }
//   }

//   Object.keys(reportGroups).forEach((key) => {
//     const rg = reportGroups[key]
//     // rg['residual'] = getResidualSum(rg.year, rg.month)
//     addVariations(rg)

//     Object.keys(rg.reports).forEach((k) => {
//       addVariations(rg.reports[k], k)
//     })
//   })

//   // Convert dicts into lists
//   reportGroups = Object.entries(reportGroups).map((r) => r[1])
//   for (const rg of reportGroups) {
//     rg.reports = Object.entries(rg.reports).map((r) => r[1])
//   }

//   return reportGroups
// }

const REPORTS = generateReports()

export const getReportsAsIssuer = () => {
  return new Promise((resolve, reject) => {
    return resolve(JSON.parse(JSON.stringify(REPORTS)))
  })
}

export const getReportsAsOperator = (operatorName) => {
  return new Promise((resolve, reject) => {
    const reportsGroups = REPORTS

    const returnReports = []

    for (const reportGroup of reportsGroups) {
      for (const report of reportGroup.reports) {
        if (report.operatorName === operatorName) {
          returnReports.push({
            reportGroupId: reportGroup.id,
            createdAt: reportGroup.createdAt,
            year: reportGroup.year,
            month: reportGroup.month,
            ...report,
          })
        }
      }
    }
    return resolve(JSON.parse(JSON.stringify(returnReports)))
    // return resolve(returnReports)
  })
}

const getReadings = (year, month, operatorName) => {
  // const _readings = AGG_RECORDS.filter(r => r.year === year && r.month === month && (operatorName ? r.operatorName === operatorName : true))
  const _readings = RECORDS.filter(
    (r) => r.year === year && r.month === month && (operatorName ? r.operatorName === operatorName : true)
  )
  // console.log(_readings)
  return JSON.parse(JSON.stringify(_readings))
}

// const getRawReadings = (year, month, operatorName) => {
//   const recs = RECORDS.filter(r => r.year === year && r.month === month &&
//       (operatorName ? r.operatorName === operatorName : true)
//   )
//   return JSON.parse(JSON.stringify(recs))
// }

const getReadingsFromTo = (from, to, operatorNames) => {
  const recs = RECORDS.filter((r) => r.opDt.isBetween(from, to, null, '[]') && operatorNames.includes(r.operatorName))
  return JSON.parse(JSON.stringify(recs))
}

// const getRawReadingsFromTo = (from, to, operatorNames) => {
//   const recs = RECORDS.filter(r => r.opDt.isBetween(from, to, null, '[]') && operatorNames.includes(r.operatorName) )
//   return JSON.parse(JSON.stringify(recs))
// }

const getReadingsWithFilters = (filters, operatorName) => {
  const conditions = [
    (r) => r.opDt.isBetween(filters.fromDt, filters.toDt, null, '[]'), // date range
  ]

  for (const filterName of Object.keys(filters.dataFilters)) {
    // Skip operator filter if is an operator
    if (operatorName && filterName === 'operatorName') continue

    if (filterName === 'fleet') {
      conditions.push((r) => filters.dataFilters[filterName].includes(r['fleetGroup']))
    } else {
      conditions.push((r) => filters.dataFilters[filterName].includes(r[filterName]))
    }

    // conditions.push((r) => filters.dataFilters[filterName].includes(r[filterName]))
  }

  if (operatorName && operatorName !== 'IP') conditions.push((r) => r.operatorName === operatorName)

  const result = RECORDS.filter((row) => conditions.every((f) => f(row)))

  return result
}

// const getRawReadingsWithFilters = (filters, operatorName) => {
//   const conditions = [
//     r => r.opDt.isBetween(filters.fromDt, filters.toDt, null, '[]') // date range
//   ]

//   for (const filterName of Object.keys(filters.dataFilters)) {
//     // Skip operator filter if is an operator
//     if (operatorName && filterName === 'operatorName') continue

//     conditions.push(r => filters.dataFilters[filterName].includes(r[filterName]))
//   }

//   if (operatorName)
//     conditions.push(r => r.operatorName === operatorName)

//   const result = RECORDS.filter(row => conditions.every(f => f(row)))

//   return JSON.parse(JSON.stringify(result))
// }

export const getFullReport = (reportId) => {
  return new Promise((resolve, reject) => {
    const repDef = reportId.split('_')
    const isReportGroup = repDef[0] === 'IP'

    let operatorName = isReportGroup ? undefined : repDef[0]
    let year = parseInt(repDef[1])
    let month = parseInt(repDef[2])

    let rp
    if (isReportGroup) {
      rp = REPORTS.find((rg) => rg.id === reportId)
    } else {
      rp = REPORTS.find((rg) => rg.id === `IP_${year}_${month}`)['reports'].find((r) => r.id === reportId)
    }

    rp['readings'] = getReadings(year, month, operatorName)
    // rp['rawReadings'] = getRawReadings(year, month, operatorName)

    rp['isReportGroup'] = isReportGroup

    return resolve(JSON.parse(JSON.stringify(rp)))
    // return resolve(rp)
  })
}

export const getAvailableRanges = () => {
  return new Promise((resolve, reject) => {
    const minDt = moment(`${REPORTS[0].year}-${String(REPORTS[0].month + 1).padStart(2, '0')}-01 00:00:00`)//.format(
    //  'YYYY-MM-DD HH:mm:ss'
    //)
    const maxDt = moment(
      `${REPORTS[REPORTS.length - 1].year}-${String(REPORTS[REPORTS.length - 1].month + 1).padStart(
        2,
        '0'
      )}-01 00:00:00`
    )
      .endOf('month')
      //.format('YYYY-MM-DD HH:mm:ss')

    return resolve(
      JSON.parse(
        JSON.stringify({
          fromDt: minDt,
          toDt: maxDt,
          dataFilters: {
            // motors: motors,
            fleet: FLEET,
            // routes: ROUTES,
            sst: SST,
            operatorName: OPERATORS,
            service: SERVICES,
          },
        })
      )
    )
  })
}

export const getData = (filters, operatorName) => {
  return new Promise((resolve, reject) => {
    const result = {
      filters: filters,
      readings: getReadingsWithFilters(filters, operatorName),
      // rawReadings: getRawReadingsWithFilters(filters, operatorName),
      // residual: getResidualSumFromTo(filters.fromDt, filters.toDt)
    }
    return resolve(result)
    // return resolve(JSON.parse(JSON.stringify(result)))
  })
}

export const getFrontPageBigNumbers = (asReportIssuer, operatorName) => {
  return new Promise((resolve, reject) => {
    // if (asReportIssuer) {

    //   let result = {
    //     consumptionVar: 0,
    //     brakingVar: 0,
    //     tripsVar:  0,
    //     kmTraveledVar: 0
    //   }

    //   // let result = {
    //   //   consumptionLast12Months: 0,
    //   //   brakingLast12Months: 0,
    //   //   tripsLast12Months:  0,
    //   //   kmTraveledLast12Months: 0
    //   // }

    //   let subs = {}

    //   for (const repGrp of REPORTS) {
    //     for (const rep of repGrp.reports) {

    //       result.consumptionLast12Months += rep.consumption
    //       result.brakingLast12Months += rep.braking
    //       result.tripsLast12Months += rep.numTrips
    //       result.kmTraveledLast12Months += rep.kmTraveled
    //       result.consumptionKm = result.consumptionLast12Months / result.kmTraveledLast12Months

    //       if (!(rep.operatorName in subs)) {
    //         subs[rep.operatorName] = {
    //           operatorName: rep.operatorName,
    //           consumptionLast12Months: 0,
    //           brakingLast12Months: 0,
    //           tripsLast12Months:  0,
    //           kmTraveledLast12Months: 0
    //         }
    //       }

    //       subs[rep.operatorName].consumptionLast12Months += rep.consumption
    //       subs[rep.operatorName].brakingLast12Months += rep.braking
    //       subs[rep.operatorName].tripsLast12Months += rep.numTrips
    //       subs[rep.operatorName].kmTraveledLast12Months += rep.kmTraveled
    //       subs[rep.operatorName].consumptionKm = subs[rep.operatorName].consumptionLast12Months / subs[rep.operatorName].kmTraveledLast12Months
    //       subs[rep.operatorName].brakingKm = subs[rep.operatorName].brakingLast12Months / subs[rep.operatorName].kmTraveledLast12Months

    //     }
    //   }

    //   result['sub'] = Object.entries(subs).map((e) => e[1])

    //   return resolve(result)

    // } else if(operatorName) {

    //   let result = {
    //     operatorName: operatorName,
    //     consumptionLast12Months: 0,
    //     tripsLast12Months:  0,
    //     brakingLast12Months: 0,
    //     kmTraveledLast12Months: 0,
    //   }

    //   for (const repGrp of REPORTS) {
    //     for (const rep of repGrp.reports) {
    //       if (rep.operatorName === operatorName) {
    //         result.consumptionLast12Months += rep.consumption
    //         result.brakingLast12Months += rep.braking
    //         result.tripsLast12Months += rep.numTrips
    //         result.kmTraveledLast12Months += rep.kmTraveled
    //       }
    //     }
    //   }

    // result['consumptionKm'] = result['consumptionLast12Months'] / result['kmTraveledLast12Months']
    // result['brakingKm'] = result['brakingLast12Months'] / result['kmTraveledLast12Months']
    const minDt = moment(`${REPORTS[0].year}-${String(REPORTS[0].month + 1).padStart(2, '0')}-01 00:00:00`)
    const maxDt = moment(
      `${REPORTS[REPORTS.length - 1].year}-${String(REPORTS[REPORTS.length - 1].month + 1).padStart(
        2,
        '0'
      )}-01 00:00:00`
    ).endOf('month')

    let result = {
      readings: getReadingsWithFilters(
        {
          fromDt: minDt,
          toDt: maxDt,
          dataFilters: {},
        },
        operatorName
      ),
      fromDt: minDt,
      toDt: maxDt, 
    }

    return resolve(JSON.parse(JSON.stringify(result)))

    // else {
    //   return reject('Invalid request')
    // }
  })
}

function getRandomDate(from, to) {
  from = from.toDate().getTime()
  to = to.toDate().getTime()
  return moment(new Date(from + Math.random() * (to - from)))
}

async function generateDummyOwnReports() {
  localStorage.removeItem('ownReports')

  const reports = []

  const ranges = await getAvailableRanges()

  for (let i = 0; i < 5; i++) {
    const fromDt = getRandomDate(moment(ranges.fromDt), moment(ranges.toDt))
    const toDt = getRandomDate(moment(fromDt), moment(ranges.toDt))

    let dataFilters = {}

    for (const key of Object.keys(ranges.dataFilters)) {
      const values = ranges.dataFilters[key]

      const numItems = randBetween(0, values.length)

      let valuesToKeep = []

      while (valuesToKeep.length < numItems) {
        const item = values[randBetween(0, values.length - 1)]
        if (valuesToKeep.includes(item)) continue
        valuesToKeep.push(item)
      }

      dataFilters[key] = valuesToKeep
    }

    reports.push({
      id: i,
      name: `Relatório ${fromDt.format('YYYY-MM-DD')} a ${toDt.format('YYYY-MM-DD')}`,
      createdAt: moment().format(),
      createdBy: getAuthentication().name,
      filters: {
        fromDt: fromDt.format(),
        toDt: toDt.format(),
        dataFilters: dataFilters,
      },
    })
  }

  localStorage.setItem('ownReports', JSON.stringify(reports))
}

export function deleteOwnReport(id) {
  return new Promise((resolve, reject) => {
    let reports = JSON.parse(localStorage.getItem('ownReports'))
    reports = reports.filter((r) => r.id !== id)
    localStorage.setItem('ownReports', JSON.stringify(reports))

    return resolve(reports)
  })
}

export function getOwnReport(id) {
  return new Promise((resolve, reject) => {
    let reports = JSON.parse(localStorage.getItem('ownReports'))
    let report = reports.find((r) => r.id !== id)
    return resolve(report)
  })
}

export function getOwnReports() {
  return new Promise((resolve, reject) => {
    let rps = JSON.parse(localStorage.getItem('ownReports'))

    if (!rps || rps.length === 0) {
      generateDummyOwnReports().then(() => {
        return resolve(JSON.parse(localStorage.getItem('ownReports')))
      })
    }

    return resolve(rps)
  })
}

export function saveOwnReport(name, filters) {
  return new Promise((resolve, reject) => {
    let reports = JSON.parse(localStorage.getItem('ownReports'))

    const newId = Math.max(...reports.map((r) => (Number.isInteger(r.id) ? r.id : 0))) + 1

    const toSave = {
      id: newId,
      name: name,
      createdAt: moment().format(),
      createdBy: getAuthentication().name,
      filters: filters,
    }

    if (reports && Array.isArray(reports)) {
      reports.push(toSave)
    } else {
      reports = [toSave]
    }

    localStorage.setItem('ownReports', JSON.stringify(reports))

    return resolve('Relatório Gravado!')
  })
}
